<template>
  <div id="store-locator-search-inner" class="p-py-md-3">
    <form @submit.prevent="onSearch">
      <div class="p-grid p-ai-stretch vertical-container">
        <div class="p-col-6 p-md-5 p-text-center" :class="{'p-md-5': displayGeolocation, 'p-lg-5': displayGeolocation}">
          <div class="box-stretched p-d-flex p-jc-center p-jc-md-end">
            <search-field v-bind:searchValue="searchString" v-on:update-search="updateSearch" @do-search="onSearchFieldSearch" v-bind:geocodingService="geocodingService" />
          </div>
        </div>
        <div class="p-col-12 p-md-2 p-d-none p-d-md-flex p-ai-center p-jc-center p-lg-2" v-show="displayGeolocation" style="font-size: 1.4rem">
            ou
        </div>
        <div class="p-col-6 p-md-5 p-text-center p-jc-center p-jc-md-start p-d-flex" v-show="displayGeolocation && geolocationIsAvailable">
          <div class="box-stretched p-d-flex p-ai-center">
            <geolocation-button @get-coordinates="onGetCoordinates" />
          </div>
        </div>
      </div>
      <div class="p-text-center p-mt-3 green" v-show="displayFilters">
        Afficher les centres proposant :
      </div>
      <div class="p-mt-3" v-show="displayFilters">
        <search-services @update-services="updateServices" :searchServices="searchServices" v-if="searchServices !== undefined" />
      </div>
      <div class="p-d-none p-mt-6 p-text-center">
        <a class="p-button p-button-primary rounded-button p-component" href="#" @click.prevent="onSearch">
          <span class="p-button-label" v-if="isLoading"><i class="pi pi-spin pi-spinner"></i></span>
          <span class="p-button-label" v-else>Rechercher</span>
        </a>
      </div>
    </form>
  </div>
</template>

<script>
import GeolocationButton from "./components/GeolocationButton";
import SearchField from "./components/SearchField";
import SearchServices from "./components/SearchServices";
import geocoding from '@mapbox/mapbox-sdk/services/geocoding';

export default {
  name: 'Store Locator Search',
  components: {GeolocationButton, SearchField, SearchServices},
  props: {
  },
  data() {
    return {
      displayGeolocation: document.getElementById("store-locator-search").dataset.displayGeolocation !== "0",
      displayFilters: document.getElementById("store-locator-search").dataset.displayFilters !== "0",
      targetPath: document.getElementById("store-locator-search").dataset.targetPath !== undefined ? document.getElementById("store-locator-search").dataset.targetPath : '/localiser-agence-123-pare-brise/',
      searchString: '',
      searchServices: [],
      geolocationIsAvailable: true,
      userLat: '',
      userLng: '',
      isLoading: false,
      searchType: null,
      geocodingService: null
    }
  },
  created() {
    // Check if geolocation is supported by the browser
    if(!("geolocation" in navigator)) {
      this.geolocationIsAvailable = false;
    }

    const mapboxAccessToken = document.body.dataset.mapboxToken ? atob(document.body.dataset.mapboxToken) : 'pk.eyJ1IjoicmJpYXJkZGF0YWlsb3IiLCJhIjoiY2tvanRlbjNzMGhpNzJvcHZxcnN1azJtYSJ9.9wYJ4Bi7A20Asr8RFBbH9A';
    this.geocodingService = geocoding({ accessToken: mapboxAccessToken })
  },
  async mounted() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let shouldSearch = false
    if (params.get('latitude') && params.get('longitude')) {
      this.userLat = params.get('latitude')
      this.userLng = params.get('longitude')
      this.searchType = params.get('searchType') || 'geoloc'
      shouldSearch = true
    }
    if (params.get('search')) {
      this.searchString = await this.geocodeString(params.get('search'))
      this.searchType = params.get('searchType') || 'near'
      shouldSearch = true
    }
    if (params.get('services')) {
      this.searchServices = params.get('services').split(',')
      shouldSearch = true
    }
    if (shouldSearch) {
      window.setTimeout(() => {
        if (window.storeLocatorBus) {
          window.storeLocatorBus.on('mapReady', () => {
            this.onSearch()
          })
        }
      }, 1000)
    }
  },
  methods: {

    async geocodeString (searchQuery) {
      if (this.geocodingService) {
        this.geocodingService.forwardGeocode({
          query: searchQuery,
          mode: 'mapbox.places',
          types: ['postcode', 'place'],
          countries: ['FR'],
          language: ['FR'],
        }).send().then((geocode) => {
          if (geocode.body && geocode.body.features && geocode.body.features.length > 0) {
            return geocode.body.features[0]
          }
        })
      }
    },

    async onSearchFieldSearch() {
      this.searchType = 'near'
      await this.onSearch()
    },

    async onSearch() {
      // Activate the spinner in the button
      this.isLoading = true;

      // Prepare the services to be set in the DOM and / or passed to the API or the store locator page
      let servicesValues = this.searchServices.join(",");

      // If we are not already on the store locator page, redirect the user with the search parameters passed in the URL.
      if(window.location.pathname !== this.targetPath) {
        let searchString = this.searchString instanceof Object ? this.searchString.place_name : this.searchString
        window.location.href = `${window.location.origin}${this.targetPath}?search=${searchString}&services=${servicesValues}&latitude=${this.userLat}&longitude=${this.userLng}&searchType=${this.searchType}`;
      } else {
        this.busEmitSearch()
      }

      // Set the text back in the button
      this.isLoading = false;
    },

    busEmitSearch() {
      if (window.storeLocatorBus) {
        window.storeLocatorBus.emit('doSearch', {
          searchType: this.searchType,
          searchString: this.searchString,
          geolocSearch: {lat: this.userLat, lng: this.userLng},
          serviceSearch: this.searchServices
        })
      }
    },

    updateServices(service) {
      // Check if the service is already in the list
      let serviceIndex = this.searchServices.indexOf(service);

      if(serviceIndex === -1) {
        this.searchServices.push(service);
      } else {
        this.searchServices.splice(serviceIndex, 1);
      }
      if (window.storeLocatorBus) {
        window.storeLocatorBus.emit('updateServiceSearch', this.searchServices)
      }
    },

    updateSearch(newValue) {
      this.searchString = newValue;
      this.searchType = 'near';
    },

    async onGetCoordinates(position) {
      this.userLat = position.coords.latitude;
      this.userLng = position.coords.longitude;
      this.searchType = 'geoloc';
      this.busEmitSearch()
    },
  }
}
</script>

<style>
#store-locator-search-inner {
  background-color: #f6f7f8;
}
</style>
